import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ContactUsModal } from '../sideMenu/contactUs/ContactUsModal';
import { SupportButton } from '../common/SupportButton';
import { CONTACT_US_STEPS } from '../sideMenu/contactUs/contactUs.constants';

import petcloudLogo from '../../assets/down-banner/petcloud-logo.svg';
import sideImage from '../../assets/down-banner/dog-grass-blue.jpg';
import alertIcon from '../../assets/down-banner/red-alert-error.svg';

import styles from './DownBanner.module.css';

const DownBanner = ({ bannerContent = { subtitle: '', title: '' } }) => {
  const { t } = useTranslation('downBanner');
  const [contactUsVisible, setContactUsVisible] = useState(false);

  return (
    <div className={styles.container}>
      <div
        className={styles.imageContainer}
        style={{ backgroundImage: `url(${sideImage})` }}
      />

      <main className={styles.content}>
        <img alt="" className={styles.logo} src={petcloudLogo} />

        <div className={styles.messageBlock}>
          <img alt="" className={styles.alertIcon} src={alertIcon} />

          {bannerContent?.title && (
            <h1 className={styles.title}>{bannerContent.title}</h1>
          )}

          {bannerContent?.subtitle && (
            <p className={styles.subtitle}>{bannerContent.subtitle}</p>
          )}
        </div>

        <footer className={styles.footer}>
          <SupportButton
            label={t('needSupport')}
            onClick={() => setContactUsVisible(true)}
          />

          <span className={styles.copyright}>
            {t('copyright', { year: new Date().getFullYear() })}
          </span>
        </footer>
      </main>

      <ContactUsModal
        companyStep={CONTACT_US_STEPS.HOME}
        onClose={() => setContactUsVisible(false)}
        show={contactUsVisible}
      />
    </div>
  );
};

export { DownBanner };
